import { Box, Stack } from '@mui/material';
import { GridColDef, DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useState } from 'react';
import { Item, WsTypography, WsTypoVariants } from 'wisestep-base';

import { YearQuarterDropdown } from '../../../../../components';
import {
  getSumOfColumnRecords,
  IClientsAnalyticsChartsProps,
} from '../helper/payloadsAndTypesHelper';
import useGetOrderbookClientWiseMonthly from '../Hooks/useGetOrderbookClientWiseMonthly';

const ClientWiseOrderBookCountAndRevenueTable = ({
  clientsAnalyticsChartsProps,
}: IClientsAnalyticsChartsProps) => {
  const paginationSize = 10;
  const tableData: Record<string, unknown>[] = [];
  const [selectedDate, setSelectedDate] = useState<string>(new Date().toString());
  const data = useGetOrderbookClientWiseMonthly(clientsAnalyticsChartsProps, selectedDate);
  data?.map((item) => {
    tableData.push({
      id: item.clientName,
      offerAcceptedCount:
        item.offerAcceptedCount1 + item.offerAcceptedCount2 + item.offerAcceptedCount3 ?? 0,
      offerAcceptedRev: (
        item.offerAcceptedRev1 + item.offerAcceptedRev2 + item.offerAcceptedRev3 ?? 0
      ).toFixed(2),
      joinedRevenue: item.joinedRev3 + item.joinedRev2 + item.joinedRev1 ?? 0,
      joinedCount: item.joinedCount1 + item.joinedCount2 + item.joinedCount3 ?? 0,
    });
  });

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Client Name', flex: 2 },
    {
      field: 'offerAcceptedCount',
      headerName: `Offer Accepted (Count)`,
      flex: 2,
    },
    {
      field: 'offerAcceptedRev',
      headerName: `Offer Accepted (Revenue)`,
      flex: 2,
    },
    {
      field: 'joinedCount',
      headerName: `Joined (Count)`,
      flex: 2,
    },
    {
      field: 'joinedRevenue',
      headerName: `Joined (Revenue)`,
      flex: 2,
    },
  ];

  return (
    <Box height="100%" width="100%">
      <Stack justifyContent="space-between" direction="row" alignItems="center">
        <Item>
          <WsTypography
            bold={true}
            variant={WsTypoVariants.TITLE}
            display="inline"
          >{`Client Wise OrderBook Count And Revenue`}</WsTypography>
        </Item>
        <Item>
          <YearQuarterDropdown pastYears={10} onDateSelect={(date) => setSelectedDate(date)} />
        </Item>
      </Stack>
      <Box mt={1} style={{ height: 670 }}>
        <DataGrid
          columns={getSumOfColumnRecords(tableData, columns, ['id'], true)}
          rows={tableData}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default ClientWiseOrderBookCountAndRevenueTable;
